import React from 'react';
import { Modal } from 'reactstrap';
import { Spinner } from "../spinner/Spinner";

export class ProgressIndicator extends React.Component {

  render(){
    return (
      <div>
        <Modal isOpen={true} modalClassName={"progress-indicator"}>
          <Spinner/>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modal/ProgressIndicator.js